import { useMemo } from 'react';
import { API_DATE_FORMAT, getDatesRange } from '../constants';

const useConvertTimeRange = (timeRange) => {
  const timeRangeValid = useMemo(
    () => timeRange && (timeRange.start ? timeRange.end || timeRange.key : timeRange.key),
    [timeRange]
  );

  const timeRangeValue = useMemo(
    () =>
      timeRangeValid
        ? {
            from: (timeRange.start || getDatesRange()[timeRange.key].start).format(API_DATE_FORMAT),
            to: (timeRange.end || getDatesRange()[timeRange.key].end).format(API_DATE_FORMAT)
          }
        : {},
    [timeRangeValid, timeRange]
  );

  return timeRangeValue;
};

export default useConvertTimeRange;
